"use client";

import React, { useContext } from "react";
import styled from "styled-components";
import RadioSlider from "@motorata/base-ui.components.atoms.radio-slider";
import { Box } from "@motorata/base-ui.components.atoms._atoms";
import Select from "@motorata/base-ui.components.atoms.select";
import { FilterContext } from "@/providers/FilterProvider";

const OffersContainerHeader = () => {
  const { filters, onChange } = useContext(FilterContext)

  return (
    <HeaderWrapper marginBottom="M">
      <RadioSlider
        name="productType"
        width="100%"
        value={filters.productType || "all"}
        onChange={onChange}
        boxShadow={false}
        options={[
          ["Wszystkie", "all"],
          ["Osobowe", "car"],
          ["Dostawcze", "truck"],
          ["Motocykle", "motorbikes"]
        ]}
        columnBreakpoint={500}
      />
      <Select
        name="sort"
        label="Sortowanie"
        value={filters.sort}
        onChange={onChange}
        background="white"
        options={[
          ["Najnowsze", "date-desc"],
          ["Najstarsze", "date-asc"],
          ["Cena rosnąco", "price-asc"],
          ["Cena malejąco", "price-desc"],
          ["Rocznik rosnąco", "year-asc"],
          ["Rocznik malejąco", "year-desc"],
          ["Przebieg rosnąco", "course-asc"],
          ["Przebieg malejąco", "course-desc"],
        ]}
      />
    </HeaderWrapper>
  );
};

export default OffersContainerHeader;


const HeaderWrapper = styled(Box)`
  display: grid;
  grid-template-columns: 1fr 250px;
  grid-gap: 2px;
  border-radius: ${({ theme }) => theme.variable.borderRadius};
  box-shadow: ${({ theme }) => theme.variable.boxShadow};
  
  @media (max-width: 800px) {
    display: block;
  };
`;
